import React, {useState, useEffect} from "react"
import { Container, Row, Col } from "reactstrap"
import * as url from "../../helpers/url_helper"

const Footer = () => {
  const [CompanyID, setCompanyID] = useState("")
  useEffect(() => {
    if (localStorage.getItem("authMildUser")) {
        const obj = JSON.parse(localStorage.getItem("authMildUser"));
        const EmployeeNo = obj.uid;
        setCompanyID(obj.activeCompany);
    }})
  return (
    <React.Fragment>
      <footer className="footer">
        <Container fluid={true}>
          <Row>
          <Col md={6}>{new Date().getFullYear()} © BRIDGE - Powered by HRP Solutions</Col>
            <Col md={6}>
              <div className="text-sm-end d-none d-sm-block">
                 {CompanyID} 
              </div>
            </Col>
          </Row>
        </Container>
      </footer>
    </React.Fragment>
  )
}

export default Footer
